import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import ProgramasPreventivosGrid from './ProgramasPreventivosGrid.js'
import ProgramasPreventivosAbm from './ProgramasPreventivosAbm.js'
import ProgramasPreventivosDetalle from './ProgramasPreventivosDetalle.js'
import { FormattedMessage } from 'react-intl';

class ProgramasPreventivos extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="programasPreventivos.header_programacion_de_preventivos" defaultMessage="Programación de Mantenimientos Preventivos"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={ProgramasPreventivosGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(routeProps) => <ProgramasPreventivosAbm {...routeProps} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id`} component={ProgramasPreventivosDetalle} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default ProgramasPreventivos;
